import React from "react";

import { CardLabel } from "@src/components/card_label/index";
import { Employee } from "@src/types";
import { Card, Flex } from "antd";
import "./proposed_employee_information_card.less";

interface ProposedEmployeeInformationCardProps {
  employee: Employee;
  status: string;
}

const ProposedEmployeeInformationCard: React.FC<
  ProposedEmployeeInformationCardProps
> = ({ employee, status }) => {
  return (
    <Card
      title={`${status} Person`}
      className="info-card proposed-employee-information-card"
    >
      <Flex vertical gap={16}>
        <CardLabel label={`${status} Person`}>{employee?.fullName}</CardLabel>
        <CardLabel label="Located">{employee?.located}</CardLabel>
        <CardLabel label="Contact Type">{employee?.contractType}</CardLabel>
      </Flex>
    </Card>
  );
};

export default ProposedEmployeeInformationCard;
